module.exports = "https://coursera_assets.s3.amazonaws.com/images/bfcf09a1403c3434243f1acc5f4d6b1f.png";